module.exports = __webpack_public_path__ + "img/bg_right.83220238.png";